import styled from 'styled-components'

export const FormContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  margin-top: 8px;
`

export const Field = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const FieldContent = styled.div`
  text-align: left;
`

export const Label = styled.label`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: #000;
`

export const RadioContainer = styled.div`
  display: flex;
  gap: 16px;

`

export const Error = styled.span`
  font-size: 12px;
  color: var(--mandy);
`

export const BottomPositioning = styled.div`
  bottom: 0;
  width: 100%;
`
